import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
let Header = class Header extends Vue {
    constructor() {
        super(...arguments);
        this.activeLink = null;
        this.vertical = false;
    }
    mounted() {
        console.log('Header.vue mounted');
        this.activeLink = this.$route.path;
    }
    onRouteChanged(to, from) {
        this.activeLink = to.path;
        this.vertical = false;
    }
};
tslib_1.__decorate([
    Watch('$route')
], Header.prototype, "onRouteChanged", null);
Header = tslib_1.__decorate([
    Component({
        name: 'editInspectionTemplate'
    })
], Header);
export default Header;
